module.exports = __webpack_public_path__ + "static/img/anxun44.3e0daa15.png";